import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";

const MiniCartItemLoader = () => {
  let isTablet = window.matchMedia("(min-width: 768px)").matches;
  return isTablet ? (
    <ContentLoader
      speed={2}
      width={600}
      height={174}
      viewBox="0 0 600 174"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="260" y="20" rx="0" ry="0" width="302" height="21" />
      <rect x="20" y="20" rx="0" ry="0" width="220" height="174" />
      <rect x="260" y="57" rx="0" ry="0" width="90" height="18" />
      <rect x="260" y="90" rx="0" ry="0" width="90" height="18" />
      <rect x="260" y="152" rx="0" ry="0" width="302" height="18" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={2}
      width={600}
      height={144}
      viewBox="0 0 600 144"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="20" y="20" rx="0" ry="0" width="142" height="100" />
      <rect x="175" y="19" rx="0" ry="0" width="300" height="12" />
      <rect x="175" y="43" rx="0" ry="0" width="80" height="12" />
      <rect x="175" y="63" rx="0" ry="0" width="80" height="12" />
      <rect x="175" y="105" rx="0" ry="0" width="300" height="12" />
    </ContentLoader>
  );
};

export default MiniCartItemLoader;
